import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { CashflowPage } from '@/components/Cashflow/CashflowPage'
import { cashflowSearchSchema, withoutSearchDefaults } from '@/components/Cashflow/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the page. */
export const Route = createFileRoute('/_app/operations/cashflow/')({
  validateSearch: cashflowSearchSchema,
  component: CashflowRoute,
})

function CashflowRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <CashflowPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutSearchDefaults, next, options))
      }
    />
  )
}
